export const commasToDots = (str: string): string => str.replace(/,/g, '.')
